/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Latency_Weighted_P50_MeaningInputs */

const en_measure_latency_weighted_p50_meaning = /** @type {(inputs: Measure_Latency_Weighted_P50_MeaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request-weighted average of endpoint p50 values, not a combined request percentile`)
};

const zh_hans1_measure_latency_weighted_p50_meaning = /** @type {(inputs: Measure_Latency_Weighted_P50_MeaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各接口 p50 按请求量加权的平均值，并非合并计算的请求百分位数`)
};

const pt_br2_measure_latency_weighted_p50_meaning = /** @type {(inputs: Measure_Latency_Weighted_P50_MeaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Média ponderada por requisições dos valores p50 dos endpoints, não um percentil combinado das requisições`)
};

const es_measure_latency_weighted_p50_meaning = /** @type {(inputs: Measure_Latency_Weighted_P50_MeaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promedio ponderado por solicitudes de los valores p50 de cada endpoint, no un percentil combinado de solicitudes`)
};

const fr_measure_latency_weighted_p50_meaning = /** @type {(inputs: Measure_Latency_Weighted_P50_MeaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyenne des valeurs p50 des endpoints pondérée par les requêtes, et non un percentile combiné des requêtes`)
};

const de_measure_latency_weighted_p50_meaning = /** @type {(inputs: Measure_Latency_Weighted_P50_MeaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Anfragen gewichteter Durchschnitt der p50-Werte der Endpoints, kein gemeinsames Perzentil über alle Anfragen`)
};

const ru_measure_latency_weighted_p50_meaning = /** @type {(inputs: Measure_Latency_Weighted_P50_MeaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Среднее значений p50 эндпоинтов, взвешенное по запросам, а не общий процентиль запросов`)
};

const it_measure_latency_weighted_p50_meaning = /** @type {(inputs: Measure_Latency_Weighted_P50_MeaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media dei valori p50 degli endpoint ponderata per richieste, non un percentile combinato delle richieste`)
};

/**
* | output |
* | --- |
* | "Request-weighted average of endpoint p50 values, not a combined request percentile" |
*
* @param {Measure_Latency_Weighted_P50_MeaningInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_weighted_p50_meaning = /** @type {((inputs?: Measure_Latency_Weighted_P50_MeaningInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_Weighted_P50_MeaningInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_weighted_p50_meaning(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_weighted_p50_meaning(inputs)
	if (locale === "es") return es_measure_latency_weighted_p50_meaning(inputs)
	if (locale === "fr") return fr_measure_latency_weighted_p50_meaning(inputs)
	if (locale === "de") return de_measure_latency_weighted_p50_meaning(inputs)
	if (locale === "ru") return ru_measure_latency_weighted_p50_meaning(inputs)
	if (locale === "it") return it_measure_latency_weighted_p50_meaning(inputs)
	return en_measure_latency_weighted_p50_meaning(inputs)
});